module.exports = __webpack_public_path__ + "static/media/nine.13f145fe.ogg";